<div class="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
    <div class="ps-3">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb mb-0 p-0">
                <li class="breadcrumb-item"><a href="javascript:;"><i class="bx bx-home-alt"></i></a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">Report</li>
            </ol>
        </nav>
    </div>
    <div class="ms-auto">
        <div class="btn-group">
          <button type="button" class="btn btn-primary" (click)="onAdd()">ADD REPORT</button>
        </div>
    </div>
</div>
<!--end breadcrumb-->

<div class="card">
    <div class="card-body">
      <div class="d-flex align-items-center">
        <h5 class="mb-0"></h5>
        <form class="ms-auto position-relative">
          <div class="position-absolute top-50 translate-middle-y search-icon px-3"><i class="bi bi-search"></i></div>
          <input class="form-control ps-5" type="text" placeholder="search">
        </form>
      </div>
      <div class="table-responsive mt-3">
        <table class="table align-middle">
          <thead class="table-secondary">
            <tr>
              <th width="40%">NAME</th>
              <th width="40%">PERIOD</th>
              <th width="10%">ACTIONS</th>
              <th width="10%" class="text-center">STATUS</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let report of reports">
              <td width="40%">
                {{ report.name }}
              </td>
              <td width="40%">{{ get_period_name(report.type) }}</td>
              <td width="10%">
                <div class="table-actions d-flex align-items-center gap-3 fs-6">
                  <i class="bi bi-pencil-fill pencil text-primary" (click)="onUpdate(report)"></i>
                  <i class="bi bi-eye-fill eye" (click)="onView(report)"></i>
                  <i class="bi bi-trash-fill trash text-danger" (click)="onDelete(report)"></i>
                </div>
              </td>
              <td width="10%" class="text-center">
                <div class="form-check form-switch form-check-reverse d-flex justify-content-center">
                    <input class="form-check-input" type="checkbox" id="listSwitch" [checked]="report.enabled" (click)="onStatusClick($event, report)">
                    <label class="form-check-label" for="listSwitch"></label>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
</div>
<div class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" id="saveReportModal" tabindex="-1"
  aria-labelledby="saveReportModalabel" aria-hidden="true">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="saveReportModalLabel">{{ save_modal_report.header }}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="onModalClose('save_report', save_modal_report)"></button>
    </div>
    <div class="form modal-body" [formGroup]="report_modal_form">
        <div class="row">
          <div class="col-md-6">
            <label class="form-label">Name</label>
            <div class="form-group">
              <input type="text" class="form-control" [class.invalid]="name.invalid && name.touched" formControlName="name"/>
              <div *ngIf="name.errors && name.invalid && name.touched">
                <small class="text-danger" *ngIf="name_errors['required']">Name is required</small>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <label class="form-label">Period</label>
            <div class="form-group">
              <select class="form-select" formControlName="period" (change)="onPeriodChanged()" [ngModelOptions]="{standalone: true}">
                <option *ngFor="let period of periods" [value]="period._id"> {{ period.name }}</option>
              </select>
              <div *ngIf="period.errors && period.invalid && period.touched">
                <small class="text-danger" *ngIf="period_errors['required']">Period is required</small>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-3">
          </div>
          <div class="col-3">
          </div>
          <div class="col-3">
          </div>
          <div class="col-3">
            <div class="btn-group float-end">
              <button type="button" class="btn btn-primary" (click)="onAddStrategy(save_modal_report)">ADD</button>
            </div>
          </div>
        </div>
        <div class="row mt-3">
            <div class="col-12 table-responsive">
                <table class="table align-middle">
                    <tbody>
                        <tr class="no-border" *ngFor="let strategy of save_modal_report.report.strategies">
                            <td width="10%">
                              <input type="text" class="form-control" [(ngModel)]="strategy.id" [ngModelOptions]="{standalone: true}"/>
                            </td>
                            <td width="20%">
                                <select class="form-select" [(ngModel)]="strategy.user_id" (change)="onUserChanged(strategy)" [ngModelOptions]="{standalone: true}">
                                    <option *ngFor="let user of users" [value]="user.user._id"> {{ user.user.full_name }}</option>
                                </select>
                            </td>
                            <td>
                                <select class="form-select" [(ngModel)]="strategy.thread_id" (change)="onUserStrategyChanged(strategy)" [ngModelOptions]="{standalone: true}">
                                    <option *ngFor="let user_strategy of strategy.threads" [value]="user_strategy._id"> {{ user_strategy.display_name }}</option>
                                </select>
                            </td>
                            <td>
                              <select class="form-select" [(ngModel)]="strategy.entry_type" [disabled]="should_disable(strategy)" [ngModelOptions]="{standalone: true}">
                                  <option *ngFor="let entry_type of entry_types" [value]="entry_type._id"> {{ entry_type.name }}</option>
                              </select>
                            </td>
                            <td>
                                <select class="form-select" [(ngModel)]="strategy.input" [ngModelOptions]="{standalone: true}">
                                    <option *ngFor="let input_type of input_types" [value]="input_type._id"> {{ input_type.name }}</option>
                                </select>
                            </td>
                            <td width="15%">
                                <input type="text" class="form-control" [(ngModel)]="strategy.capital" [ngModelOptions]="{standalone: true}"/>
                            </td>
                            <td>
                                <div class="table-actions d-flex align-items-center gap-3 fs-6">
                                    <i class="bi bi-trash-fill trash text-danger" (click)="onDeleteRow(save_modal_report, strategy)"></i>&nbsp;&nbsp;
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button class="btn btn-danger btn-block" data-dismiss="modal" (click)="onModalClose('save_report', save_modal_report)">
          CANCEL
        </button>
        <button class="btn btn-primary" (click)="saveReport(save_modal_report)" [disabled]="report_modal_form.invalid">
          {{ save_modal_report.btn_text }}
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" data-backdrop="static" data-keyboard="false" id="viewReportModal" tabindex="-1" role="dialog"
  aria-labelledby="viewReportModalabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="viewReportModalLabel">{{ view_modal_report.header }}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="onModalClose('view_report', view_modal_report)"></button>
    </div>
    <div class="form container modal-body">
        <div class="row mt-3">
            <div class="col-9">
            </div>
            <div class="col-3">
                <input type="date" autocomplete="off" class="form-control" [(ngModel)]="view_modal_report.date" (change)="onDateChanged(view_modal_report)">
            </div>
        </div>
        <div class="row mt-3" *ngFor="let strategy of view_modal_report.report.strategies">
          <div class="row">
            <div class="col get-data-header">
              <div class="form-check">
                <input class="form-check-input shadow-none" (change)="on_no_data(strategy)" [(ngModel)]="strategy.no_data" type="checkbox" value="" id="flexCheckDefault">
                <label class="form-check-label" for="flexCheckDefault">
                  No Data
                </label>
              </div>
            </div>
            <div class="col-8 text-center get-data-header">
              {{ get_user_name(strategy.user_id) }} - {{ get_strategy_name(strategy.user_id, strategy.thread_id) }} - {{ get_input_type(strategy) }}
            </div>
            <div class="col get-data-header">
            </div>
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">Name</th>
                  <th scope="col">Symbol</th>
                  <th scope="col"></th>
                  <th scope="col"></th>
                  <th scope="col"></th>
                  <th scope="col"></th>
                  <th scope="col"></th>
                  <th scope="col">Strike</th>
                  <th scope="col">Option</th>
                  <th scope="col">Quantity</th>
                  <th scope="col">Buy Price</th>
                  <th scope="col">Sell Price</th>
                </tr>
              </thead>
              <tbody *ngFor="let row of strategy.rows">
                <tr>
                  <td>
                    <input type="text" class="form-control" [disabled]="strategy.no_data" [(ngModel)]="row.strategy_name" [ngModelOptions]="{standalone: true}"/>
                  </td>
                  <td colspan="6">
                    <div class="input-group">
                      <input type="text" class="form-control" [disabled]="strategy.no_data" placeholder="Symbol"  aria-describedby="button-symbol" [(ngModel)]="row.symbol" [ngModelOptions]="{standalone: true}"/>
                      <!-- <button class="btn btn-default btn-img-bg" id="button-symbol">
                        <i class="bi bi-pencil-fill pencil text-primary" (click)="openSymbolSelection()"></i>
                      </button> -->
                    </div>
                  </td>
                  <td>
                    <input type="text" class="form-control" [disabled]="strategy.no_data" [(ngModel)]="row.strike_price" [ngModelOptions]="{standalone: true}"/>
                  </td>
                  <td>
                    <input type="text" class="form-control" [disabled]="strategy.no_data" [(ngModel)]="row.option_type" [ngModelOptions]="{standalone: true}"/>
                  </td>
                  <td>
                    <input type="text" class="form-control" [disabled]="strategy.no_data" [(ngModel)]="row.qty" [ngModelOptions]="{standalone: true}"/>
                  </td>
                  <td>
                    <input type="text" class="form-control" [disabled]="strategy.no_data" [(ngModel)]="row.buy_price" [ngModelOptions]="{standalone: true}"/>
                  </td>
                  <td>
                    <input type="text" class="form-control" [disabled]="strategy.no_data" [(ngModel)]="row.sell_price" [ngModelOptions]="{standalone: true}"/>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary btn-block" data-dismiss="modal" (click)="downloadReport(view_modal_report)">
          DOWNLOAD
        </button>
        <button class="btn btn-primary btn-block" data-dismiss="modal" (click)="showReport(view_modal_report)">
          SHOW
        </button>
        <div class="input-group auto-width">
          <button class="btn btn-success btn-block" data-dismiss="modal" (click)="generateReport(view_modal_report)">
            {{ view_modal_report.generate_btn_txt }}
          </button>
          <button type="button" class="btn btn-success dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown" aria-expanded="false">
            <span class="visually-hidden">Toggle Dropdown</span>
          </button>
          <ul class="dropdown-menu">
            <li><a class="dropdown-item" (click)="updateGenerateButton(view_modal_report, 'regular')">Regular</a></li>
            <li><a class="dropdown-item" (click)="updateGenerateButton(view_modal_report, 'force')">Force</a></li>
          </ul>
        </div>
        <button class="btn btn-primary btn-block" data-dismiss="modal" (click)="updateDatas(view_modal_report)">
          UPDATE
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" data-backdrop="static" data-keyboard="false" id="selectSymbolModal" tabindex="-1" role="dialog"
  aria-labelledby="selectSymbolModalabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="selectSymbolModalLabel">{{ select_symbol_params.header }}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="onModalClose('select_symbol', select_symbol_params)"></button>
    </div>
    <div class="form container modal-body">
        <div class="row mt-3">
            <div class="col-4">
              <select class="form-select" [(ngModel)]="select_symbol_params.category" (change)="onCategoryChanged(select_symbol_params)" [ngModelOptions]="{standalone: true}">
                <option *ngFor="let category of categories" [value]="category._id"> {{ category.name }}</option>
              </select>
            </div>
            <div class="col-4">
              <select class="form-select" [(ngModel)]="select_symbol_params.segment" (change)="onSegmentChanged(select_symbol_params)" [ngModelOptions]="{standalone: true}">
                <option *ngFor="let segment of segments" [value]="segment._id"> {{ segment.name }}</option>
              </select>
            </div>
            <div class="col-4">
              <select class="form-select" [(ngModel)]="select_symbol_params.symbol" [ngModelOptions]="{standalone: true}">
                <option *ngFor="let symbol of select_symbol_params.symbols" [value]="symbol._id"> {{ symbol.name }}</option>
              </select>
            </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-danger btn-block" data-dismiss="modal" (click)="onModalClose('select_symbol', select_symbol_params)">
          CANCEL
        </button>
        <button class="btn btn-success btn-block" data-dismiss="modal" (click)="onSymbolSelected(select_symbol_params)">
          OK
        </button>
      </div>
    </div>
  </div>
</div>

<div id="deleteReportConfirmationModal" class="modal" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">ALERT</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <p>Are you sure want to delete this report?</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="deleteReport(0)">Close</button>
          <button type="button" class="btn btn-danger" (click)="deleteReport(1)">Delete</button>
        </div>
      </div>
    </div>
</div>

<div id="enableReportConfirmationModal" class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">ALERT</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="updateReportStatus(0, enableParams.report)"></button>
        </div>
        <div class="modal-body">
          <p>Are you sure want to {{ enableParams.type }} this strategy?</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="updateReportStatus(0, enableParams.report)">Close</button>
          <button type="button" class="btn" [ngClass]="enableParams.action_class" (click)="updateReportStatus(1, enableParams.report)">{{ enableParams.action }}</button>
        </div>
      </div>
    </div>
</div>
